import { applicationApi } from '@api/application/application.api';

export const {
  useLazyLoadApplicationsQuery,
  useAddApplicationMutation,
  useLazyLoadApplicationQuery,
  useLazyGetAccessTokenQuery,
  useDeleteApplicationMutation,
} = applicationApi;
